import React from 'react'
import { Link, useLocation } from 'react-router-dom';
import './index.less';

/**
 *   头部配置
 */

const HEADER_DATA = [
  {
    name: 'SUPPLIER',
    path: 'https://www.dsers.com/developers/supplier-app/',
    blank: true,
  },
  {
    name: 'SALES CHANNEL',
    path: 'https://www.dsers.com/developers/channel-app/',
    blank: true,
  },
  {
    name: 'API Introduction',
    path: '/pricing/',
    childrens: [
      {
        name: 'Overview',
        path: 'https://www.dsers.com/developers/api-overview/',
        blank: true
      },
      {
        name: "Auth Service",
        path: '/auth_service',
        blank: true
      },
      {
        name: 'Channel APP',
        path: '/api/channel_app_api',
        blank: true,
      },
      {
        name: 'Middle Platform For Channel APP',
        path: '/api/channel_middle_platform_api',
        blank: true,
      },
      {
        name: 'Supplier APP',
        path: '/api/supplier_app_api',
        blank: true,
      },
      {
        name: 'Middle Platform For Supplier APP',
        path: '/api/supplier_middle_platform_api',
        blank: true,
      },
      {
        name: 'Status And Error Codes',
        path: '/status_and_error_codes',
        blank: true,
      }
    ],
  },
];

const NavDropdown = ({ item }) => {
  return (
    <div className="nav-item dropdown" style={{ textTransform: 'uppercase' }}>
      {item.name}
      <div className="nav-dropdown" >
        <ul className="childrens">
          {item?.childrens?.map((itemKey, index) => {
            return (
              <li key={index}>
                {itemKey.blank ? (
                  <div className="childrens_hover" style={{ textTransform: 'uppercase' }}>
                    <a href={itemKey.path} target="_blank" rel="noreferrer">
                      {itemKey.name}
                    </a>
                  </div>
                ) : (
                  <div className="childrens_hover" style={{ textTransform: 'uppercase' }}>
                    <Link to={itemKey.path}>{itemKey.name}</Link>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};


export const Header = () => {

  const origin = process.env.REACT_APP_DSERS_USER_CENTER_ORIGIN;

  let API_REVIEW = false;

  const location = useLocation();

  if (location.hash.includes('#/')) {
    API_REVIEW = true
  }

  return <div className='header_container'>
    <div className='header' style={API_REVIEW ? { width: '100%', padding: '0 32px' } : null}>
      <div className="header_box">
        <Link to="/" className="logo">
          <img src="https://img.dsers.com/dsevs_dev/Logo.svg" alt="DSers logo" />
        </Link>
        <ul className="ul" style={API_REVIEW ? { marginLeft: '150px' } : null}>
          {HEADER_DATA.map((item, i) => {
            return (
              <li key={i} >
                {item?.childrens ? (
                  <NavDropdown item={item} />
                ) : (
                  <Link className="nav-item" to={item.path} target="_blank" style={{ textTransform: 'uppercase' }}>
                    {item.name}
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
        <div className="login_box">
          <a className="try_it_free header_register"
            href={`${origin}/accounts/login?from=dev`}
          >
            LOGIN
          </a>
          <a
            href={`${origin}/accounts/register?from=dev`}
            className="login header_login"
          >
            CREATE ACCOUNT
          </a>
        </div>
      </div>
    </div>
  </div>
}